(function (factory) {
	var moduleName = "ccsLenovoShowcase";

	if (typeof ccs_define === "function") {
		ccs_define(moduleName,
			[
				"jquery",
				"autoheight",
				"Fancybox"
			],
			factory);
		return;
	}

	var moduleExport = factory(window.ccsJq);
	if (typeof moduleExport !== "undefined") {
		window[moduleName] = moduleExport;
	}
}
(function ($) {
	window.ccs_cc_lenovoShowcase = {

		/* Initializes Lenovo showcase features.
		----------------------------------------------------------*/
		init: function () {

			var c = {
				topMenu: {
					itemSelector: ".ccs-cc-lenovo-showcase-topmenu td[data-submenu-id]",
					linkSelector: ".ccs-cc-lenovo-showcase-topmenu td[data-submenu-id] > a",
					submenuSelector: ".ccs-cc-lenovo-showcase-topmenu-submenu[data-submenu-id='{0}']",
					submenuIdAttr: "data-submenu-id",
					activeClass: "active"
				},

				autoHeight: {
					activeSubmenuSelector: ".ccs-cc-lenovo-showcase-topmenu td.active .ccs-cc-lenovo-showcase-topmenu-submenu",
					headerSelector: ".ccs-cc-lenovo-showcase-header",
					topMenuSelector: ".ccs-cc-lenovo-showcase-topmenu",
					activeSubmenuMargin: 10
				},

				compare: {
					buttonSelector: ".ccs-cc-lenovo-showcase-details a[data-compare-button]"
				},

				links: {
					linkSelector: ".ccs-cc-lenovo-showcase-link",
					areaSelector: "div[data-link-area]"
				}
			};

			setupTopMenu();
			setupLinks();
			setupSpecs();
			setupCompareLightbox();
			setupAutoHeight();

			/* Setups links properties.
			----------------------------------------------------------*/
			function setupLinks() {
				$(c.links.linkSelector).click(function (evt) {
					switchArea(evt);
				});
			}

			/* Switch to another link area.
			----------------------------------------------------------*/
			function switchArea(evt) {
				var $currentlink = $(evt.currentTarget);
				var $links = $(c.links.linkSelector);
				var $linkAreas = $(c.links.areaSelector);

				$linkAreas.hide();
				$links.removeClass("selected");
				$currentlink.addClass("selected");

				var linkId = $currentlink.attr("data-link-id");
				var $currentLinkArea = $("#" + linkId);

				$currentLinkArea.css("opacity", 0);
				$currentLinkArea.show();
				$currentLinkArea.animate(
					{ opacity: 1 },
					{
						duration: 250,
						queue: false
					});
			}

			/* Setups specification properties.
			----------------------------------------------------------*/
			function setupSpecs() {

				var content = $("div.ccs-cc-lenovo-showcase-content");

				content.find("div.table-products div.spec-link > a")
					.click(function () {
						expandOrCollapseSpec($(this));
					});

				content.find("div.table-accessories div.spec-link > a")
					.click(function () {
						expandOrCollapseSpec($(this));
					});
				}

			/* Expands or collapses specification area.
			----------------------------------------------------------*/
			function expandOrCollapseSpec(link) {

				var imgExpand = link.find("img.icon-expand");
				var imgCollapse = link.find("img.icon-collapse");

				var specId = link.data("specId");
				var specRow = $("#" + specId);

				if (specRow.is(':visible')) {
					imgCollapse.hide();
					imgExpand.show();
					specRow.hide();
				} else {
					imgExpand.hide();
					imgCollapse.show();
					specRow.show('fast');
				}
			}

			/* Compare lightbox
			----------------------------------------------------------*/
			function setupCompareLightbox () {
				var $button = $(c.compare.buttonSelector);
				$button.fancybox({ smallBtn: true });
			}

			/* Setup autoheight
			----------------------------------------------------------*/
			function setupAutoHeight() {
				setupCustomGetHeightFunc();

				var topMenuLinks = $(c.topMenu.itemSelector);
				topMenuLinks.on({
					mouseenter: function () {
						$(this).addClass(c.topMenu.activeClass);
						ccs_autoheightSender.sendHeightUpdateRequest();
					},
					mouseleave: function () {
						$(this).removeClass(c.topMenu.activeClass);
						ccs_autoheightSender.sendHeightUpdateRequest();
					}
				});
			}

			function setupCustomGetHeightFunc () {
				var headerHeigth = $(c.autoHeight.headerSelector).height();
				var topmenuHeight = $(c.autoHeight.topMenuSelector).height();

				var calculateBodyHeigth = function () {
					var bodyHeight = $("body").height();
					var activeSubmenuHeight = $(c.autoHeight.activeSubmenuSelector).height();

					var bodyHeightWithActiveSubmenu = headerHeigth + topmenuHeight + activeSubmenuHeight;
					if (bodyHeight > bodyHeightWithActiveSubmenu) {
						return bodyHeight;
					}

					return bodyHeightWithActiveSubmenu + c.autoHeight.activeSubmenuMargin;
				};

				ccs_autoheightSender.customGetHeight(calculateBodyHeigth);
			}

			/* Setup top menu link height
			----------------------------------------------------------*/
			function setupTopMenu () {
				var $topMenuItem = $(c.topMenu.itemSelector).first();
				var topMenuItemHeight = $topMenuItem.outerHeight();

				var $topMenuLinks = $(c.topMenu.linkSelector);
				var linkPaddingTop = parseInt($topMenuLinks.first().css("paddingTop"));
				var linkPaddingBottom = parseInt($topMenuLinks.first().css("paddingBottom"));

				$topMenuLinks.height(topMenuItemHeight - linkPaddingTop - linkPaddingBottom);
			}
		}
	};
}));